<div class="claim-information">
  @if (hasTitle) {
    <div class="claim-information-header section-heading"
      data-cy="claim-information-title">Claim information
    </div>
  }
  <div class="claim-information-content">
    <div class="claim-information-column left">
      <div class="grid-item claim-information-partner">
        <app-input-dropdown #partnerInput
          (inputStateChange)="managePartnerInputStateChange($event)"
          (inputValueChange)="setPartnerValue($event)"
          [inputFormatter]="typeahead.inputTextCodeNameFormatter"
          [messages]="partnerInputMessages"
          [resultFormatter]="typeahead.inputTextCodeNameFormatter"
          [resultsFunction]="searchPartners"
          [validators]="validators.partner"
          [warningLevel]="WarningEnum.WARNING"
          baseCypressTag="claim-information-partner"
          label="Partner"
        placeholder="Select partner"></app-input-dropdown>
      </div>

      <div class="grid-item claim-information-supplying-packing-plant">
        <app-input-dropdown #supplyingPackingPlantInput
          (inputStateChange)="manageSupplyingPackingPlantInputStateChange($event)"
          (inputValueChange)="setSupplyingPackingPlantValue($event)"
          [inputFormatter]="typeahead.inputTextCodeNameFormatter"
          [messages]="supplyingPackingPlantInputMessages"
          [resultFormatter]="typeahead.inputTextCodeNameFormatter"
          [resultsFunction]="searchSupplyingPackingPlants"
          [showMessagesWhenDisabled]="true"
          [validators]="validators.supplyingPackingPlant"
          [warningLevel]="WarningEnum.WARNING"
          baseCypressTag="claim-information-supplying-packing-plant"
          label="Supplying packing plant"
        placeholder="Select supplying packing plant"></app-input-dropdown>
      </div>

      <div class="grid-item claim-information-claim-code">
        <app-input-dropdown #claimCodeInput
          (inputStateChange)="manageClaimCodeInputStateChange($event)"
          (inputValueChange)="setClaimCodeValue($event)"
          [inputFormatter]="typeahead.inputTextCodeNameFormatter"
          [messages]="claimCodeInputMessages"
          [resultFormatter]="typeahead.inputTextCodeNameFormatter"
          [resultsFunction]="searchClaimCodes"
          [showMessagesWhenDisabled]="true"
          [validators]="validators.claimCode"
          [warningLevel]="WarningEnum.WARNING"
          baseCypressTag="claim-information-claim-code"
          label="Claim code"
        placeholder="Search or select claim code"></app-input-dropdown>
      </div>

      <div class="grid-item claim-information-material">
        <app-input-autocomplete #materialInput
          (inputStateChange)="manageMaterialInputStateChange($event)"
          (inputValueChange)="setMaterialValue($event)"
          [inputFormatter]="typeahead.inputTextNumberDescriptionFormatter"
          [messages]="materialInputMessages"
          [resultFormatter]="typeahead.inputTextNumberDescriptionFormatter"
          [resultsFunction]="searchMaterials"
          [showMessagesWhenDisabled]="true"
          [validators]="validators.material"
          [warningLevel]="WarningEnum.WARNING"
          baseCypressTag="claim-information-material"
          label="Material"
        placeholder="Search for material"></app-input-autocomplete>
      </div>

      <div class="grid-item claim-information-model-type">
        <app-input-text #modelTypeInput
          (inputStateChange)="manageModelTypeChange($event)"
          (inputValueChange)="setModelTypeValue($event)"
          [maxLength]="4"
          [messages]="modelTypeInputMessages"
          [validators]="validators.modelType"
          baseCypressTag="claim-information-model-type"
          label="Model type"
        placeholder="e.g. AA00"></app-input-text>
      </div>

      <div class="grid-item claim-information-model-code">
        <app-input-text #modelCodeInput
          (inputStateChange)="manageModelCodeChange($event)"
          (inputValueChange)="setModelCodeValue($event)"
          [maxLength]="3"
          [messages]="modelCodeInputMessages"
          [validators]="validators.modelCode"
          baseCypressTag="claim-information-model-code"
          label="Model code"
        placeholder="e.g. A00"></app-input-text>
      </div>

      <div class="grid-item claim-information-lot-number">
        <app-input-text #lotNumberInput
          (inputStateChange)="manageLotNumberChange($event)"
          (inputValueChange)="setLotNumberValue($event)"
          [maxLength]="4"
          [messages]="lotNumberInputMessages"
          [validators]="validators.lotNumber"
          baseCypressTag="claim-information-lot-number"
          label="LOT number"
        placeholder="e.g. 0000"></app-input-text>
      </div>

      <div class="grid-item claim-information-mcdr-number">
        <app-input-text #mcdrNumberInput
          (inputStateChange)="manageMcdrNumberChange($event)"
          (inputValueChange)="setMcdrNumberValue($event)"
          [maxLength]="9"
          [messages]="mcdrNumberInputMessages"
          [validators]="validators.mcdrNumber"
          baseCypressTag="claim-information-mcdr-number"
          label="MCDR"
        placeholder="e.g. 00000000"></app-input-text>
      </div>

      <div class="grid-item claim-information-subject">
        <app-input-text #subjectInput
          (inputStateChange)="manageSubjectChange($event)"
          (inputValueChange)="setSubjectValue($event)"
          [hasSearchIcon]="false"
          [maxLength]="40"
          [messages]="subjectInputMessages"
          [validators]="validators.subject"
          [warningLevel]="WarningEnum.INFO"
          baseCypressTag="claim-information-subject"
          label="Subject"
        placeholder="Enter claim subject"></app-input-text>
      </div>

      <div class="grid-item claim-information-spo-number">
        <app-input-text #spoNumberInput
          (inputStateChange)="manageSPONumberChange($event)"
          (inputValueChange)="setSPONumberValue($event)"
          [isToUpperCaseInputTextValue]="true"
          [hasSearchIcon]="false"
          [maxLength]="10"
          [messages]="spoNumberInputMessages"
          [validators]="validators.spoNumber"
          baseCypressTag="claim-information-spo-number"
          label="SPO number"
        placeholder="e.g. S000000000"></app-input-text>
      </div>

      <div class="grid-item claim-information-description">
        <app-input-textarea #descriptionInput
          (inputStateChange)="manageDescriptionChange($event)"
          (inputValueChange)="setDescriptionValue($event)"
          [hasSearchIcon]="false"
          [height]="128"
          [maxLength]="400"
          [messages]="descriptionInputMessages"
          [validators]="validators.description"
          [warningLevel]="WarningEnum.INFO"
          baseCypressTag="claim-information-description"
          label="Description"
        placeholder="Enter description"></app-input-textarea>
      </div>
    </div>

    <div class="claim-information-column right">
      @if (showAttachments()) {
        <div>
          <div class="label-wrapper">
            <div class="label-star">
              <label data-cy="claim-information-attachments-label">Attachments</label>
              @if (requiredAttachments) {
                <app-warning-star
                  [type]="WarningEnum.INFO"
                data-cy="claim-information-attachments-warning-star"></app-warning-star>
              }
            </div>
            @if (state.fileManagerOffline) {
              <button (click)="refreshClick()"
                class="btn-text-link btn-refresh"
                data-cy="claim-information-attachments-button-refresh">
                <span class="iwp-icon-gen_refresh icon-refresh"></span>
                <span>Refresh</span>
              </button>
            }
          </div>
          @if (state.fileManagerOffline) {
            <app-drag-and-drop-error
            message="Please use the refresh button to reattempt a communication."></app-drag-and-drop-error>
          } @else {
            @for (item of template.attachments; track trackByIndex($index, item)) {
              <div class="progress-bar"
                data-cy="claim-information-form-attachment-item">
                <app-upload-progress (deleteFile)="discardUpload(item)"
                  (downloadFile)="downloadFile($event)"
                  (isOverlayOpen)="updateOverlayItem(item)"
                  (retryUpload)="uploadFileCall(item.file)"
                  [deletePermissions]="hasDeletePermissions()"
                  [file]="item.file"
                  [isDeleting]="isDeleting"
                  [isDownloading]="item.isDownloading"
                  [isPrevious]="item.isPrevious"
                  [showOverlay]="item.overlayInProgress"
                  [uploadEvent]="item.event"
                  [uploadFailed]="item.failed"
                  class="claim-information-attachments-upload-progress"
                data-cy="claim-information-attachments-upload-progress"></app-upload-progress>
              </div>
            }
            <div>
              <app-drag-and-drop (fileDropped)="uploadFile($event)"
                [disable]="disableDragAndDropArea()"
                [uploadAreaLabel]="uploadAreaLabel"
              data-cy="claim-information-attachments-drag-and-drop"></app-drag-and-drop>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
